/* Reviewcarrousel — Costa Rio, 30-09.
   Stond eerst als <script> in sections/product-reviews.liquid, maar Shopify haalt inline
   scripts uit sectiebestanden weg (de tag verdween uit de gerenderde pagina). Daarom hier.
   Werkt voor elke .rvwrap op de pagina, dus ook voor de reviewband op de homepage.

   08-10 (Gianni): op mobiel begon de carrousel bij review 2 en sprong hij tijdens het
   swipen terug. Drie oorzaken, alle drie hieronder gefixt:
   1. de beginstand stond hard op index 1 — dat klopt alleen als er drie kaarten naast
      elkaar passen; past er maar één, dan begin je bij 0;
   2. beginstand() draaide nog een tweede keer op window.load en zette de rail terug,
      ook als je toen al aan het swipen was;
   3. het resize-event vuurt op mobiel bij elk verdwijnen van de adresbalk (alleen de
      hoogte verandert) en sprong dan terug naar het midden van de kaart. */
(function () {
  function bouw(wrap) {
    var rail = wrap.querySelector('[data-rv-rail]');
    var dots = wrap.querySelector('[data-rv-dots]');
    if (!rail || wrap.dataset.rvKlaar) return;
    wrap.dataset.rvKlaar = '1';
    var kaarten = Array.prototype.slice.call(rail.children);
    if (kaarten.length < 2) { if (dots) dots.remove(); return; }
    var huidig = 0, timer = null, pauze = null, aangeraakt = false;
    var laatsteBreedte = window.innerWidth;

    kaarten.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'rvdot';
      d.setAttribute('aria-label', 'Avaliação ' + (i + 1));
      d.addEventListener('click', function () { aangeraakt = true; naar(i, 'smooth'); wacht(); });
      dots.appendChild(d);
    });
    var knoppen = Array.prototype.slice.call(dots.children);

    /* Past er maar één kaart op het scherm (telefoon), dan is er geen middelste kaart
       om op te starten en hoort review 1 gewoon vooraan te staan. */
    function eenPerScherm() { return kaarten[0].offsetWidth > rail.clientWidth * 0.75; }
    function beginIndex() { return (kaarten.length > 2 && !eenPerScherm()) ? 1 : 0; }

    function naar(i, gedrag) {
      var k = kaarten[i];
      if (!k) return;
      huidig = i;
      rail.scrollTo({ left: k.offsetLeft - (rail.clientWidth - k.offsetWidth) / 2, behavior: gedrag || 'auto' });
    }
    function midden() {
      var c = rail.scrollLeft + rail.clientWidth / 2, best = 0, beste = Infinity;
      kaarten.forEach(function (k, i) {
        var d = Math.abs(k.offsetLeft + k.offsetWidth / 2 - c);
        if (d < beste) { beste = d; best = i; }
      });
      huidig = best;
      kaarten.forEach(function (k, i) { k.classList.toggle('is-active', i === best); });
      knoppen.forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
    }
    function start() { stop(); timer = setInterval(function () { naar((huidig + 1) % kaarten.length, 'smooth'); }, 5000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function wacht() { stop(); clearTimeout(pauze); pauze = setTimeout(start, 9000); }
    function raakAan() { aangeraakt = true; wacht(); }

    rail.addEventListener('scroll', function () { window.requestAnimationFrame(midden); });
    rail.addEventListener('pointerdown', raakAan);
    rail.addEventListener('touchstart', raakAan, { passive: true });
    rail.addEventListener('wheel', raakAan, { passive: true });
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', function () { clearTimeout(pauze); start(); });
    window.addEventListener('resize', function () {
      /* alleen bij een echte breedteverandering; op mobiel vuurt resize ook als de
         adresbalk in- of uitschuift en dan mag de carrousel niet verspringen */
      if (window.innerWidth === laatsteBreedte) return;
      laatsteBreedte = window.innerWidth;
      naar(huidig);
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    function beginstand() { naar(beginIndex()); midden(); start(); }
    window.requestAnimationFrame(beginstand);
    /* na het laden kan de layout nog verschoven zijn (lettertypen, foto's); opnieuw
       uitlijnen mag dan wél, maar niet als de bezoeker al zelf geswipet heeft */
    window.addEventListener('load', function () { if (!aangeraakt) { naar(beginIndex()); midden(); } });
  }
  function alles() { document.querySelectorAll('.rvwrap').forEach(bouw); }
  document.addEventListener('DOMContentLoaded', alles);
  document.addEventListener('shopify:section:load', alles);   /* thema-editor */
  alles();
})();
